module.exports = __webpack_public_path__ + "static/img/arr-right.aff73346.png";